<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpBox>
      <ItpText
        muted
        class="mb-0"
      >
        {{ resourceTitle }}
      </ItpText>
    </ItpBox>
    <ItpText
      tag="h4"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <DIV
    class="btn-toolbar ml-auto flex-nowrap"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto mr-2"
      v-if="!isNew"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      variant="light"
      icon="icon-park-outline:preview-open"
      :href="protocol.preview_url"
      :tooltip="'Open preview'|pgettext('ContractProtocol')"
      target="_blank"
      use-auth
      show-spinner
      class="ml-auto mr-2"
      v-if="protocol.preview_url"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Complete'|pgettext('HandoverProtocol|Command')"
        :tooltip="'Complete'|pgettext('HandoverProtocol|CommandTooltip')"
        variant="default"
        v-if="!protocol.isNew && protocol.meta.can_complete"
        @click.prevent.stop="evh_4942415580156499_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Cancel'|pgettext('HandoverProtocol|Command')"
        :tooltip="'Cancel or invalidate the event.'|pgettext('HandoverProtocol|CommandTooltip')"
        variant="default"
        v-if="!protocol.isNew && protocol.meta.can_invalidate"
        @click.prevent.stop="evh_49312645155713_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!protocol.isNew && protocol.meta.can_lock"
        @click.prevent.stop="evh_237785848579802_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!protocol.isNew && protocol.meta.can_unlock"
        @click.prevent.stop="evh_6883979544763359_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="protocol"
        :tooltip="'Delete protocol'|pgettext('Payment')"
        :disabled="protocol.isNew || protocol.protocol_status != 'draft'"
        v-if="!isNew"
        @success="evh_3329008617875226_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractProtocolHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  protocol!: object;

  @Watch('protocol')
  onProtocol(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("protocol")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          handoverTypes: {
            moving_in: this.$fn.pgettext("HandoverType", "Moving-in protocol"),
            moving_out: this.$fn.pgettext("HandoverType", "Moving-out protocol"),
          }
          ,
          newTransaction: this.$fn.pgettext("ContractProtocol", "New protocol"),
          editTransaction: this.$fn.pgettext("ContractProtocol", "Edit protocol"),
        }
        ,
        ux: null,
      },
    }
  }

  get isNew() {
    if (this.loaded) {

      return this.protocol.isNew
    }
    return null;
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.handoverTypes[this.protocol.handover_type]
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.isNew ? this.messages.newTransaction : this.messages.editTransaction
    }
    return null;
  }

  async act_1040167445267876_emit_8658_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_8658, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4942415580156499_closeComponent_8662_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_4942415580156499_closeComponent_8662, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_4942415580156499_crud_8660_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_4942415580156499_crud_8660, alias=complete
    return {
      objectType: "contract_protocol",
      op: "upsert",
      data: { ...this.protocol, protocol_status: 'completed' },
    }
  }

  async act_4942415580156499_crud_8660_getConfirm($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_4942415580156499_crud_8660, alias=complete
    return {
      header: "Jegyőkönyv véglegesítése",
      message: "A jegyzőkönyv véglegesítés után már nem módosítható.",
      btnOk: "Véglegesítés",
      severity: "warning",
    }
  }

  async evh_4942415580156499_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4942415580156499_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_49312645155713_emit_8666_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_49312645155713_emit_8666, alias=undefined
    return {
      event: "close",
    }
  }

  async act_49312645155713_crud_8664_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_49312645155713_crud_8664, alias=complete
    return {
      objectType: "contract_protocol",
      op: "upsert",
      data: { ...this.protocol, protocol_status: 'cancelled' },
    }
  }

  async act_49312645155713_crud_8664_getConfirm($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_49312645155713_crud_8664, alias=complete
    return {
      header: "Jegyőkönyv érvénytelenítése",
      message: "A jegyzőkönyv érvénytelenítés után már nem módosítható.",
      btnOk: "Érvénytelenítés",
      severity: "warning",
    }
  }

  async evh_49312645155713_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_49312645155713_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_237785848579802_emit_8670_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_237785848579802_emit_8670, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_237785848579802_request_8668_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_237785848579802_request_8668, alias=lock
    return {
      url: this.protocol.links.self,
      method: "patch",
      data: {
        etag: this.protocol.etag,
        locked: true,
      },
    }
  }

  async evh_237785848579802_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_237785848579802_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6883979544763359_emit_8674_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_6883979544763359_emit_8674, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_6883979544763359_request_8672_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6883979544763359_request_8672, alias=lock
    return {
      url: this.protocol.links.self,
      method: "patch",
      data: {
        etag: this.protocol.etag,
        locked: false,
      },
    }
  }

  async evh_6883979544763359_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6883979544763359_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3329008617875226_emit_8676_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3329008617875226_emit_8676, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_3329008617875226_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3329008617875226_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_emit_8658: actions.EmitAction;
    evh_1040167445267876_clickPreventStop_8657: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
    act_4942415580156499_closeComponent_8662: actions.CloseComponentAction;
    evh_4942415580156499_success_8661: actions.EventHandlerImpl;
    act_4942415580156499_crud_8660: actions.CRUDAction;
    evh_4942415580156499_clickPreventStop_8659: actions.EventHandlerImpl;
    evh_4942415580156499_clickPreventStop: actions.EventHandlerGroup;
    act_49312645155713_emit_8666: actions.EmitAction;
    evh_49312645155713_success_8665: actions.EventHandlerImpl;
    act_49312645155713_crud_8664: actions.CRUDAction;
    evh_49312645155713_clickPreventStop_8663: actions.EventHandlerImpl;
    evh_49312645155713_clickPreventStop: actions.EventHandlerGroup;
    act_237785848579802_emit_8670: actions.EmitAction;
    evh_237785848579802_success_8669: actions.EventHandlerImpl;
    act_237785848579802_request_8668: actions.RequestAction;
    evh_237785848579802_clickPreventStop_8667: actions.EventHandlerImpl;
    evh_237785848579802_clickPreventStop: actions.EventHandlerGroup;
    act_6883979544763359_emit_8674: actions.EmitAction;
    evh_6883979544763359_success_8673: actions.EventHandlerImpl;
    act_6883979544763359_request_8672: actions.RequestAction;
    evh_6883979544763359_clickPreventStop_8671: actions.EventHandlerImpl;
    evh_6883979544763359_clickPreventStop: actions.EventHandlerGroup;
    act_3329008617875226_emit_8676: actions.EmitAction;
    evh_3329008617875226_success_8675: actions.EventHandlerImpl;
    evh_3329008617875226_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_emit_8658 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_8658_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_8657 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_8658,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_8657],
      }
    );
    const act_4942415580156499_closeComponent_8662 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_4942415580156499_closeComponent_8662_getActionArgs,
        events: [],
      }
    );
    const evh_4942415580156499_success_8661 = new actions.EventHandlerImpl(
      {
        action: act_4942415580156499_closeComponent_8662,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_4942415580156499_crud_8660 = new actions.CRUDAction(
      {
        actionArgs: this.act_4942415580156499_crud_8660_getActionArgs,
        confirm: this.act_4942415580156499_crud_8660_getConfirm,
        displayName: "complete",
        events: [evh_4942415580156499_success_8661],
      }
    );
    const evh_4942415580156499_clickPreventStop_8659 = new actions.EventHandlerImpl(
      {
        action: act_4942415580156499_crud_8660,
        event: "click.prevent.stop",
        displayName: "complete",
      }
    );
    const evh_4942415580156499_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4942415580156499_clickPreventStop_8659],
      }
    );
    const act_49312645155713_emit_8666 = new actions.EmitAction(
      {
        actionArgs: this.act_49312645155713_emit_8666_getActionArgs,
        events: [],
      }
    );
    const evh_49312645155713_success_8665 = new actions.EventHandlerImpl(
      {
        action: act_49312645155713_emit_8666,
        event: "success",
        displayName: "emit",
      }
    );
    const act_49312645155713_crud_8664 = new actions.CRUDAction(
      {
        actionArgs: this.act_49312645155713_crud_8664_getActionArgs,
        confirm: this.act_49312645155713_crud_8664_getConfirm,
        displayName: "complete",
        events: [evh_49312645155713_success_8665],
      }
    );
    const evh_49312645155713_clickPreventStop_8663 = new actions.EventHandlerImpl(
      {
        action: act_49312645155713_crud_8664,
        event: "click.prevent.stop",
        displayName: "complete",
      }
    );
    const evh_49312645155713_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_49312645155713_clickPreventStop_8663],
      }
    );
    const act_237785848579802_emit_8670 = new actions.EmitAction(
      {
        actionArgs: this.act_237785848579802_emit_8670_getActionArgs,
        events: [],
      }
    );
    const evh_237785848579802_success_8669 = new actions.EventHandlerImpl(
      {
        action: act_237785848579802_emit_8670,
        event: "success",
        displayName: "emit",
      }
    );
    const act_237785848579802_request_8668 = new actions.RequestAction(
      {
        actionArgs: this.act_237785848579802_request_8668_getActionArgs,
        displayName: "lock",
        events: [evh_237785848579802_success_8669],
      }
    );
    const evh_237785848579802_clickPreventStop_8667 = new actions.EventHandlerImpl(
      {
        action: act_237785848579802_request_8668,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_237785848579802_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_237785848579802_clickPreventStop_8667],
      }
    );
    const act_6883979544763359_emit_8674 = new actions.EmitAction(
      {
        actionArgs: this.act_6883979544763359_emit_8674_getActionArgs,
        events: [],
      }
    );
    const evh_6883979544763359_success_8673 = new actions.EventHandlerImpl(
      {
        action: act_6883979544763359_emit_8674,
        event: "success",
        displayName: "emit",
      }
    );
    const act_6883979544763359_request_8672 = new actions.RequestAction(
      {
        actionArgs: this.act_6883979544763359_request_8672_getActionArgs,
        displayName: "lock",
        events: [evh_6883979544763359_success_8673],
      }
    );
    const evh_6883979544763359_clickPreventStop_8671 = new actions.EventHandlerImpl(
      {
        action: act_6883979544763359_request_8672,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_6883979544763359_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6883979544763359_clickPreventStop_8671],
      }
    );
    const act_3329008617875226_emit_8676 = new actions.EmitAction(
      {
        actionArgs: this.act_3329008617875226_emit_8676_getActionArgs,
        events: [],
      }
    );
    const evh_3329008617875226_success_8675 = new actions.EventHandlerImpl(
      {
        action: act_3329008617875226_emit_8676,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_3329008617875226_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3329008617875226_success_8675],
      }
    );
    return {
      act_1040167445267876_emit_8658,
      evh_1040167445267876_clickPreventStop_8657,
      evh_1040167445267876_clickPreventStop,
      act_4942415580156499_closeComponent_8662,
      evh_4942415580156499_success_8661,
      act_4942415580156499_crud_8660,
      evh_4942415580156499_clickPreventStop_8659,
      evh_4942415580156499_clickPreventStop,
      act_49312645155713_emit_8666,
      evh_49312645155713_success_8665,
      act_49312645155713_crud_8664,
      evh_49312645155713_clickPreventStop_8663,
      evh_49312645155713_clickPreventStop,
      act_237785848579802_emit_8670,
      evh_237785848579802_success_8669,
      act_237785848579802_request_8668,
      evh_237785848579802_clickPreventStop_8667,
      evh_237785848579802_clickPreventStop,
      act_6883979544763359_emit_8674,
      evh_6883979544763359_success_8673,
      act_6883979544763359_request_8672,
      evh_6883979544763359_clickPreventStop_8671,
      evh_6883979544763359_clickPreventStop,
      act_3329008617875226_emit_8676,
      evh_3329008617875226_success_8675,
      evh_3329008617875226_success,
      reload: act_1040167445267876_emit_8658,
      complete: act_49312645155713_crud_8664,
      lock: act_6883979544763359_request_8672,
    }
  }
}

Vue.component("UcContractProtocolHeader", UcContractProtocolHeader);

</script>